import React from "react";

interface ReceiptFormSectionProps {
  id: string;
  icon: string;
  label: string;
  children: React.ReactNode;
}

const ReceiptFormSection: React.FC<ReceiptFormSectionProps> = ({ id, icon, label, children }) => (
  <section aria-labelledby={`${id}-heading`}>
    <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
      <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
      <i className={`fa ${icon} mr-2`} aria-hidden="true" style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }} />
      <h6 id={`${id}-heading`} style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
        {label}
      </h6>
      <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
    </div>
    {children}
  </section>
);

export default ReceiptFormSection;
